define('entities/sales_inbox',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (App, $, _, Backbone, Settings) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.SalesInboxItem = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      emailMessageSecId: null,
      emailMessageIdHeader: null,
      subject: '',
      senderEmail: '',
      customerName: '',
      customerVip: false,
      receivedAt: null,
      inboxType: 'SALES',
      category: null,
      emailCase: null,
      locale: null,
      potential: null,
      potentialValue: 0,
      latestOfferValue: 0,
      customerValue: 0,
      priorityScore: 0,
      status: 'NEW',
      assignedUserpidSecId: null,
      assignedUserpidName: '',
      assignedGroupSecId: null,
      assignedGroupName: '',
      classificationConfidence: null,
      classificationSource: null,
      classifiedAt: null,
      firstResponseAt: null,
      resolvedAt: null,
      manualOverride: false,
      labels: [],
      note: null,
      extracted: null,
      extractionAppliedAt: null,
      replyDueAt: null,
      urgencyBonus: 0
    },
    idAttribute: 'secId'
  });

  App.reqres.setHandler('salesInbox:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.SalesInboxItem, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.SalesInboxItem(json);
  });

  var API = {
    listUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox', params); },
    countUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/rowCount', params); },
    detailUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId); },
    contextUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/context'); },
    assignUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign'); },
    assignUserUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign-user'); },
    assignGroupUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign-group'); },
    statusUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/status'); },
    classificationUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/classification'); },
    localeUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/locale'); },
    replyDueUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/reply-due'); },
    noteUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/note'); },
    // Sales ⇄ support: same table, the item just changes inbox.
    transferUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/inbox'); },
    applyExtractionUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/apply-extraction'); },
    documentTargetsUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/document-targets'); },
    ordersUrl: function (secId, poi) {
      return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/orders' + (poi ? '/' + encodeURIComponent(poi) : ''));
    },
    statsUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/stats', params); },
    // Lightweight, server-cached per-locale barometer data (separate from the
    // heavy full-stats call).
    barometerUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/stats/barometer', params); },
    routingRulesUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules', params); },
    routingRulesCountUrl: function () { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules/rowCount'); },
    routingRuleUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules/' + secId); },
    // Auto-resolve rules (Admin): matching mail is resolved at classification.
    autoResolveRulesUrl: function (path) {
      return Settings.url('compuzz2', 'v2/sales-inbox/auto-resolve-rules' + (path ? '/' + path : ''));
    },
    // Worklist screen: pending work grouped per company (open inbox emails +
    // the offers sitting in a sales/graph "action required" status).
    worklistUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/worklist', params); },
    worklistTimelineUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/worklist/timeline', params); },
    worklistClosedUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/worklist/closed', params); },
    worklistOpenUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/worklist/open', params); },
    // Support worklist: supplier-side work, one card per order.
    supportWorklistUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/support-worklist', params); },
    statusChecksUrl: function () { return Settings.url('compuzz2', 'v2/sales-inbox/support-worklist/checks'); },
    statusCheckUrl: function (poi) {
      return Settings.url('compuzz2', 'v2/sales-inbox/support-worklist/checks/' + encodeURIComponent(poi));
    },
    resetCheckUrl: function (poi) {
      return Settings.url('compuzz2', 'v2/sales-inbox/support-worklist/checks/' + encodeURIComponent(poi) + '/reset');
    }
  };

  // Everything that ever happened with one worklist block, newest first.
  // `params` carries companySecId or customerSecId (and an optional limit).
  App.reqres.setHandler('salesInbox:worklist-timeline', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.worklistTimelineUrl(params || {}),
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // The closed work of one block, fetched only when its folded section is
  // opened — the window's own call carries just the count.
  App.reqres.setHandler('salesInbox:worklist-closed', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.worklistClosedUrl(params || {}),
      success: function (data) { defer.resolve(data); },
      error: function (err) { defer.reject(err); }
    });
    return defer.promise();
  });

  // The open work of ONE block, for a screen that already knows which company
  // it is about (the company file) instead of paging the whole board.
  // 204 = the company is known but has nothing pending: resolved as null.
  // The inbox item of a mail, by its Gmail message id: {secId, inboxType}, or
  // null when the mail is in no inbox (yet). Where a mail notification leads.
  App.reqres.setHandler('salesInbox:by-message', function (messageId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: Settings.url('compuzz2', 'v2/sales-inbox/by-message/' + encodeURIComponent(messageId)),
      success: function (data, status, xhr) {
        defer.resolve(xhr.status === 204 ? null : data);
      },
      error: function (err) { defer.reject(err); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:worklist-open', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.worklistOpenUrl(params || {}),
      success: function (data, status, xhr) {
        defer.resolve(xhr.status === 204 ? null : data);
      },
      error: function (err) { defer.reject(err); }
    });
    return defer.promise();
  });

  // One page of the worklist: {total, first, pageSize, customers}. The total
  // travels with the page on purpose — the blocks are assembled in memory
  // server-side, so a separate count call would redo the whole assembly.
  App.reqres.setHandler('salesInbox:worklist', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.worklistUrl(params || {}),
      success: function (data) {
        defer.resolve({
          total: (data && data.total) || 0,
          customers: (data && data.customers) || []
        });
      },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // One page of the support worklist: {total, first, pageSize, blocks, and the
  // per-kind card counts emailBlocks / proofBlocks / lateBlocks / statusBlocks}.
  // Returns the jqXHR itself so the board can abort a superseded request.
  App.reqres.setHandler('salesInbox:support-worklist', function (params) {
    return $.ajax({ type: 'GET', url: API.supportWorklistUrl(params || {}) });
  });

  // Orders past their status's "need check" delay: [{purchaseOrderId,
  // statusCode, checkAfterHours, since, dueAt, checkedBefore}]. The orders
  // board puts a clock on these cards.
  App.reqres.setHandler('salesInbox:status-checks', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.statusChecksUrl(),
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Need-check state of one order/offer: resolves with its check, or null when
  // it is not past its status delay (204).
  App.reqres.setHandler('salesInbox:status-check', function (poi) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.statusCheckUrl(poi),
      success: function (data, status, xhr) { defer.resolve(xhr.status === 204 ? null : data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // "Checked" on the support worklist's Late item: hidden for 24 h.
  App.reqres.setHandler('salesInbox:late-checked', function (poi) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: Settings.url('compuzz2', 'v2/sales-inbox/support-worklist/late/' + encodeURIComponent(poi) + '/checked'),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // "Checked": the order's status delay counts again from now.
  App.reqres.setHandler('salesInbox:reset-check', function (poi) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.resetCheckUrl(poi),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:list-url', API.listUrl);
  App.reqres.setHandler('salesInbox:count-url', API.countUrl);

  // ── Shared sales-inbox filter state ───────────────────────────────────
  // The list screen persists its selected filters here; the header badge
  // reads the same key so its count always reflects what the user is
  // currently looking at. Both go through buildFilterParams() so the query
  // params can never drift between the two views.
  //
  // The sales and the support inbox are the same list with an `inbox` filter;
  // each keeps its own persisted filters (the badge counts the sales one).
  var FILTER_STORAGE_KEY = 'salesInbox.listFilters';
  var SUPPORT_FILTER_STORAGE_KEY = 'supportInbox.listFilters';

  function filterStorageKey(inbox) {
    return inbox === 'SUPPORT' ? SUPPORT_FILTER_STORAGE_KEY : FILTER_STORAGE_KEY;
  }

  function loadSalesInboxFilters(inbox) {
    try {
      var raw = window.localStorage && window.localStorage.getItem(filterStorageKey(inbox));
      var filters = raw ? JSON.parse(raw) : {};
      if (inbox === 'SUPPORT') { filters.inbox = 'SUPPORT'; }
      return filters;
    } catch (e) { return inbox === 'SUPPORT' ? { inbox: 'SUPPORT' } : {}; }
  }

  function buildFilterParams(filters) {
    filters = filters || {};
    var params = {};
    _.each(['inbox', 'potential', 'category', 'emailCase', 'locale', 'status', 'userSecId', 'groupSecId', 'search'], function (key) {
      if (filters[key]) { params[key] = filters[key]; }
    });
    if (filters.unassigned) { params.unassigned = true; }
    if (filters.myGroups)   { params.myGroups = true; }
    if (filters.vip)        { params.vip = true; }
    // Extended search: the mail content too (Gmail on the server side).
    if (filters.searchMode === 'extended' && filters.search) { params.searchMode = 'extended'; }
    return params;
  }

  // Build the query params from a given filter object, or from the
  // persisted filters when none is supplied. The list view passes its own
  // in-memory filters; the header badge relies on the persisted ones.
  App.reqres.setHandler('salesInbox:filter-params', function (filters) {
    return buildFilterParams(filters || loadSalesInboxFilters());
  });

  // The persisted list filters of one inbox ('SALES' when omitted), and the
  // key they live under — shared by the list (writes) and the detail's
  // prev/next (reads).
  App.reqres.setHandler('salesInbox:load-filters', loadSalesInboxFilters);
  App.reqres.setHandler('salesInbox:filter-storage-key', filterStorageKey);

  // Count of sales-inbox items matching the filters currently selected on
  // the list screen. Backed by the same rowCount endpoint the list paginates
  // with, so the badge and the list footer always agree.
  App.reqres.setHandler('salesInbox:header-count', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      // The badge polls: never the (Gmail-backed) extended search.
      url: API.countUrl(_.omit(buildFilterParams(loadSalesInboxFilters()), 'searchMode')),
      success: function (data) {
        var n = typeof data === 'number' ? data : (data && data.count) || 0;
        defer.resolve(n);
      },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.detailUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:context', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.contextUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:assign', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Side-specific assignment handlers — each preserves the OTHER side
  // (use these instead of `salesInbox:assign` when only one side changes).
  App.reqres.setHandler('salesInbox:assign-user', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignUserUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ userpidSecId: userpidSecId || null }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:assign-group', function (secId, groupSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignGroupUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ groupSecId: groupSecId || null }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:status', function (secId, status) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.statusUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ status: status }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:set-locale', function (secId, locale) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.localeUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ locale: locale }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Set, move or clear (null) the reply deadline by hand. `replyDueAt` is a
  // local ISO date-time ("2026-09-30T14:00", Brussels) or a bare day.
  App.reqres.setHandler('salesInbox:set-reply-due', function (secId, replyDueAt) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.replyDueUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ replyDueAt: replyDueAt || null }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:reclassify', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.classificationUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Move an item to the other inbox. payload: {inboxType, category?, emailCase?}.
  App.reqres.setHandler('salesInbox:transfer', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.transferUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Write the item's extracted tracking / dates into an order.
  // payload: {purchaseOrderId?, tracking, dates}. Rejects with the xhr; a 409
  // carries {error: 'no_linked_order' | 'choose_order' | 'nothing_extracted'}.
  App.reqres.setHandler('salesInbox:apply-extraction', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.applyExtractionUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Tie the email to an order by hand: reference = our order number or the
  // supplier's. Resolves with the email's linked orders; rejects with the xhr
  // (404 {error:'order_not_found'} when nothing matches).
  App.reqres.setHandler('salesInbox:link-order', function (secId, reference) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.ordersUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ reference: reference }),
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Untie the email from one of its orders. Resolves with the remaining links.
  App.reqres.setHandler('salesInbox:unlink-order', function (secId, poi) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.ordersUrl(secId, poi),
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Offers / orders an attachment of this item's email can be filed into:
  // [{purchaseOrderId, offer, productName, status, source: 'email'|'customer'}].
  App.reqres.setHandler('salesInbox:document-targets', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.documentTargetsUrl(secId),
      success: function (data) { defer.resolve(data || []); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Copy an email attachment into an offer/order's internal documents: fetch
  // the file from the mailbox, then post it to the order's documents upload —
  // the same call as dropping a file in the order's Documents tab.
  App.reqres.setHandler('salesInbox:attachment-to-documents', function (downloadUrl, fileName, purchaseOrderId) {
    var defer = $.Deferred();
    var xhr = new XMLHttpRequest();
    xhr.open('GET', downloadUrl);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status !== 200) { defer.reject(xhr); return; }
      var formData = new FormData();
      formData.append('file', xhr.response, fileName);
      formData.append('filename', fileName);
      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'attachments/commandDocuments/' + purchaseOrderId + '/upload'),
        data: formData,
        processData: false,
        contentType: false,
        success: function (attachment) { defer.resolve(attachment); },
        error: function (err) { defer.reject(err); }
      });
    };
    xhr.onerror = function () { defer.reject(xhr); };
    xhr.send();
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:note', function (secId, note) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.noteUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ note: note }),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:stats', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.statsUrl(params || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:barometer', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.barometerUrl(params || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:routing-rules:list-url', API.routingRulesUrl);
  App.reqres.setHandler('salesInbox:routing-rules:count-url', API.routingRulesCountUrl);

  App.reqres.setHandler('salesInbox:routing-rules:create', function (payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.routingRulesUrl({}),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:routing-rules:update', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.routingRuleUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:auto-resolve-rules:list', function () {
    return $.ajax({ type: 'GET', url: API.autoResolveRulesUrl() });
  });

  // Create (secId null) or update.
  App.reqres.setHandler('salesInbox:auto-resolve-rules:save', function (secId, payload) {
    return $.ajax({
      type: secId ? 'PUT' : 'POST',
      url: API.autoResolveRulesUrl(secId || ''),
      contentType: 'application/json',
      data: JSON.stringify(payload || {})
    });
  });

  App.reqres.setHandler('salesInbox:auto-resolve-rules:delete', function (secId) {
    return $.ajax({ type: 'DELETE', url: API.autoResolveRulesUrl(secId) });
  });

  // The open mails a rule (saved or not) would resolve now: {count, truncated, samples}.
  // Returns the jqXHR so the editor can abort a superseded preview.
  App.reqres.setHandler('salesInbox:auto-resolve-rules:preview', function (payload) {
    return $.ajax({
      type: 'POST',
      url: API.autoResolveRulesUrl('preview'),
      contentType: 'application/json',
      data: JSON.stringify(payload || {})
    });
  });

  // Resolves the open mails a saved rule matches: {resolved}.
  App.reqres.setHandler('salesInbox:auto-resolve-rules:apply', function (secId) {
    return $.ajax({ type: 'POST', url: API.autoResolveRulesUrl(secId + '/apply') });
  });

  App.reqres.setHandler('salesInbox:routing-rules:delete', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.routingRuleUrl(secId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

